    <div *ngIf="!healthCardFinished" 
      class="product-share-container custom-theme-modal modal-dialog modal-dialog-centered" 
      role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="row">
            <div class="col-6 pr-0 mb-3 heading-4">
              <p class="color-grey-700">
                {{mls?.languageText?.product_share?.key1}}<span *ngIf="mls?.is_lskey_display == 1">(product_share.key1)</span>
              </p>
            </div>

            <div class="col-6 text-right close-icon">
              <span class="cursor-pointer"
              (click)="fcs.closeWebModal()">
                <img src="assets/themes/icons/cancel.svg" alt="close icon">
              </span>
            </div>
          </div>
        </div>
    
        <span *ngIf="finished==true" class='text-center'>
          <img src="assets/themes/images/primary-loader.gif" 
            width="20" 
            height="20" 
            id="loadmore_post">
        </span>
    
        <div class="modal-body pt-2 pb-2" *ngIf="finished==false">
          <div class="custom-dropdown form-input mb-4" >
            <span class="icon-right cursor-pointer" 
              (click)="fcs.copyLink(share_url)">
              <img src="assets/themes/icons/copy.svg" 
                alt="copy icon" />
              </span>
            <div class="input-field">
              <div class="share-url-text ellipsis">
                {{share_url}}
              </div>
              <span class="position-absolute share-modal-copy ellipsis cursor-pointer secondary-paragraph-bold" 
                (click)="fcs.copyLink(share_url)">
                {{mls?.languageText?.product_share?.key2}}<span *ngIf="mls?.is_lskey_display == 1">(product_share.key2)</span>
              </span>
            </div>
          </div>
          <hr class="mt-2 mb-4"/>
          <p class="secondary-paragraph mb-3">
            <span class="color-grey-500">{{mls?.languageText?.product_share?.key3}}<span *ngIf="mls?.is_lskey_display == 1">(product_share.key3)</span></span>
          </p>
          <div class="row pl-1 mb-4">
            <div class="col-3 text-center" (click)="fbShare()">
              <a target="_blank" class="cursor-pointer secondary-paragraph-bold">
                <img class="share-icon rounded-circle  icon-hover mb-3" 
                  src="assets/themes/icons/facebook.svg" 
                  alt="facebook icon" />
                <br/>
                {{mls?.languageText?.product_share?.key4}}<span *ngIf="mls?.is_lskey_display == 1">(product_share.key4)</span>
              </a>
            </div>
            <div class="col-3 text-center" (click)="liShare()">
              <p class="cursor-pointer secondary-paragraph-bold">
                <img class="share-icon rounded-circle  icon-hover mb-3" 
                  src="assets/themes/icons/in.svg" 
                  alt="linkedIn icon" />
                <br/>
                  {{mls?.languageText?.product_share?.key5}}<span *ngIf="mls?.is_lskey_display == 1">(product_share.key5)</span>
              </p>
            </div>
            <div class="col-3 text-center"  (click)="twShare()">
              <p class="cursor-pointer secondary-paragraph-bold">
                <img class="share-icon rounded-circle  icon-hover mb-3" 
                  src="assets/themes/icons/twitter.svg" 
                  alt="twitter icon" />
                <br/>
                  {{mls?.languageText?.product_share?.key6}}<span *ngIf="mls?.is_lskey_display == 1">(product_share.key6)</span>
              </p>
            </div>
            <div class="col-3 text-center" (click)="sendMail()">
              <p class="cursor-pointer secondary-paragraph-bold">
                <img class="share-icon rounded-circle  icon-hover mb-3" 
                  src="assets/themes/icons/email.svg" 
                  alt="email icon" />
                <br/>
                  {{mls?.languageText?.product_share?.key7}}<span *ngIf="mls?.is_lskey_display == 1">(product_share.key7)</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="healthCardFinished" 
      class="product-share-container custom-theme-modal modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="row">
            <div class="col-6 pr-0 mb-5 heading-4">
              <p class="color-grey-700">
                {{mls?.languageText?.product_share?.key1}}
                <span
                  *ngIf="mls?.is_lskey_display == 1">(product_share.key1)</span>
              </p>
            </div>
    
            <div class="col-6 text-right">
              <span class="cursor-pointer" 
                (click)="fcs.closeWebModal()">
                <img src="assets/themes/icons/cancel.svg" 
                  alt="close icon" />
              </span>
            </div>
          </div>
        </div>
        <span *ngIf="!healthCardFinished" class='text-center'>
          <img src="assets/themes/images/primary-loader.gif" 
            width="20" 
            height="20" 
            id="loadmore_post" />
        </span>
        <div class="modal-body py-2" 
          *ngIf="healthCardFinished">
          <div class="position-relative">
            <img 
              [src]="imageEncodedUrl" 
              alt="Share banner" />
          </div>
          <hr />
          <p class="secondary-paragraph">
            <span class="color-grey-500">{{mls?.languageText?.product_share?.key3}}</span>
            <span *ngIf="mls?.is_lskey_display == 1">(product_share.key3)</span>
          </p>
          <div class="row pl-1">
            <div class="col-3 text-center" 
              (click)="fbShare()">
              <a target="_blank" 
                class="cursor-pointer secondary-paragraph-bold">
                <img class="share-icon rounded-circle  icon-hover mb-3" 
                  src="assets/themes/icons/facebook.svg" 
                  alt="facebook icon" />
                <br />
                {{mls?.languageText?.product_share?.key4}}<span
                  *ngIf="mls?.is_lskey_display == 1">(product_share.key4)</span>
              </a>
            </div>
            <div class="col-3 text-center" 
              (click)="liShare()">
              <p class="cursor-pointer secondary-paragraph-bold">
                <img class="share-icon rounded-circle  icon-hover mb-3" 
                  src="assets/themes/icons/in.svg" 
                  alt="linkedIn icon" />
                <br />
                {{mls?.languageText?.product_share?.key5}}<span
                  *ngIf="mls?.is_lskey_display == 1">(product_share.key5)</span>
              </p>
            </div>
            <div class="col-3 text-center" 
              (click)="twShare()">
              <p class="cursor-pointer secondary-paragraph-bold">
                <img class="share-icon rounded-circle  icon-hover mb-3" 
                  src="assets/themes/icons/twitter.svg" 
                  alt="twitter icon" />
                <br />
                {{mls?.languageText?.product_share?.key6}}<span
                  *ngIf="mls?.is_lskey_display == 1">(product_share.key6)</span>
              </p>
            </div>
            <div class="col-3 text-center" 
              (click)="sendMail()">
              <p class="cursor-pointer secondary-paragraph-bold">
                <img class="share-icon rounded-circle  icon-hover mb-3" 
                  src="assets/themes/icons/email.svg" 
                  alt="email icon" />
              <br />
                {{mls?.languageText?.product_share?.key7}}<span
                  *ngIf="mls?.is_lskey_display == 1">(product_share.key7)</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>